// extracted by mini-css-extract-plugin
export var BtnContent = "index-module--BtnContent--NBXMi";
export var inner = "index-module--inner--NAhie";
export var logo = "index-module--logo--VPZ0-";